import { combineReducers, Action, createFeatureSelector } from '@ngrx/store';
import {State as CoreState} from '@emm/core/store/core.reducer';
import {
    attributesFeatureKey,
    attributesReducer,
    AttributesState
} from '@emm/management/store/attributes/attributes.reducer';
import {baseFeatureKey, managementBaseReducer, BaseState} from '@emm/management/store/base/management-base.reducer';
import {
    consumerTypesFeatureKey,
    consumerTypesReducer, ConsumerTypesState
} from '@emm/management/store/consumer-types/consumer-types.reducer';
import {
    emergencyItemsFeatureKey,
    operatorLocksReducer,
    OperatorLocksState
} from './emergency-items/operator-locks.reducer';
import {
    itemGroupingsFeatureKey,
    itemGroupingsReducer, ItemGroupingsState
} from '@emm/management/store/item-groupings/item-groupings.reducer';
import {itemsFeatureKey, itemsReducer, ItemsState} from '@emm/management/store/items/items.reducer';
import {
    itemTypeClassesFeatureKey,
    itemTypeClassesReducer, ItemTypeClassesState
} from '@emm/management/store/item-type-classes/item-type-classes.reducer';
import {
    itemTypesFeatureKey,
    itemTypesReducer,
    ItemTypesState
} from '@emm/management/store/item-types/item-types.reducer';
import {
    locationSetsFeatureKey,
    locationSetsReducer,
    LocationSetsState
} from '@emm/management/store/location-sets/location-sets.reducer';
import {
    locationSetTypesFeatureKey,
    locationSetTypesReducer,
    LocationSetTypesState
} from './location-set-types/location-set-types.reducer';
import {
    masterMenuFeatureKey,
    masterMenuReducer,
    MasterMenuState
} from '@emm/management/store/mms-revote/master-menu-system.reducer';
import {
    mmsAdminFeatureKey,
    mmsAdminReducer,
    MmsAdminState
} from '@emm/management/store/mms-admin-override/mms-admin-override.reducer';
import {nutritionFeatureKey, nutritionReducer, NutritionState} from '@emm/management/store/nutrition/nutrition.reducer';
import {
    languageAssignmentsFeatureKey, languageAssignmentsReducer,
    LanguageAssignmentsState
} from '@emm/management/store/language-assignments/language-assignments.reducer';


export const managementFeatureKey = 'management';

export interface ManagementState {
    [attributesFeatureKey]: AttributesState;
    [baseFeatureKey]: BaseState;
    [consumerTypesFeatureKey]: ConsumerTypesState;
    [emergencyItemsFeatureKey]: OperatorLocksState;
    [itemGroupingsFeatureKey]: ItemGroupingsState;
    [itemsFeatureKey]: ItemsState;
    [itemTypeClassesFeatureKey]: ItemTypeClassesState;
    [itemTypesFeatureKey]: ItemTypesState;
    [locationSetsFeatureKey]: LocationSetsState;
    [locationSetTypesFeatureKey]: LocationSetTypesState;
    [masterMenuFeatureKey]: MasterMenuState;
    [mmsAdminFeatureKey]: MmsAdminState;
    [nutritionFeatureKey]: NutritionState;
    [languageAssignmentsFeatureKey]: LanguageAssignmentsState;
}

export interface State extends CoreState {
    [managementFeatureKey]: ManagementState;
}

export function managementReducers(state: ManagementState | undefined, action: Action) {
    return combineReducers({
        [attributesFeatureKey]: attributesReducer,
        [baseFeatureKey]: managementBaseReducer,
        [consumerTypesFeatureKey]: consumerTypesReducer,
        [emergencyItemsFeatureKey]: operatorLocksReducer,
        [itemGroupingsFeatureKey]: itemGroupingsReducer,
        [itemsFeatureKey]: itemsReducer,
        [itemTypeClassesFeatureKey]: itemTypeClassesReducer,
        [itemTypesFeatureKey]: itemTypesReducer,
        [locationSetsFeatureKey]: locationSetsReducer,
        [locationSetTypesFeatureKey]: locationSetTypesReducer,
        [masterMenuFeatureKey]: masterMenuReducer,
        [mmsAdminFeatureKey]: mmsAdminReducer,
        [nutritionFeatureKey]: nutritionReducer,
        [languageAssignmentsFeatureKey]: languageAssignmentsReducer,
    })(state, action);
}

export const getManagementState = createFeatureSelector<State, ManagementState>(managementFeatureKey);
